import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromArticleModalStore from '@purplefront/article-modal/data-access';
import { getLatestArticles, selectLatestArticles } from '@purplefront/article-modal/data-access';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AppRouterFacadeService } from '@purplefront/app-router/data-access';

@Component({
  selector: 'app-latest-articles',
  templateUrl: './latest-articles.component.html',
  styleUrls: ['./latest-articles.component.scss']
})
export class LatestArticlesComponent implements OnInit, OnChanges {
  @Input() article: any;
  @Output() scrollToTop = new EventEmitter();
  @Output() searchString$ = new EventEmitter<string>();
  latestArticles$: Observable<any>;

  constructor(
    private _articleModalStore: Store<fromArticleModalStore.ArticleModalState>,
    private _router: Router,
    private _appRouterFacade: AppRouterFacadeService
  ) {}

  ngOnInit(): void {
    this.getLatestArticles();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.article &&
      changes.article.previousValue &&
      changes.article.previousValue !== changes.article.currentValue
    ) {
      this.getLatestArticles();
    }
  }

  getLatestArticles(): void {
    const payload = {
      mainCategory: this.article.mainCategory,
      lang: this.article.lang,
      articleId: this.article.id
    };
    this._articleModalStore.dispatch(getLatestArticles(payload));
    this.latestArticles$ = this._articleModalStore.pipe(select(selectLatestArticles));
  }
  showArticle(article) {
    this.scrollToTop.emit();
    this._appRouterFacade.goToArticlePage(article);
  }

  search($event: string) {
    this.searchString$.emit($event);
  }
}
